export default "/_next/static/assets/images/sprite.e190fab1ce0049f114bfe6fffc23c436.svg";